import { useMutation, useQueryClient } from '@tanstack/react-query'
import { handleHttpErrors } from '../../shared'
import { showErrorToast, showSuccessToast } from '@bpinternal/ui-kit-next'
import { getApiClient } from '../../stores'
import type { ClientInputs } from '@botpress/client'
import { useQueryKeys } from '../useQueryKeys'

type deleteFileParams = ClientInputs['deleteFile']

export function useDeleteFile({ botId, workspaceId }: { workspaceId: string; botId: string }) {
  const queryClient = useQueryClient()

  const listFilesQueryKey = useQueryKeys().listFiles({ botId, workspaceId })

  return useMutation({
    mutationFn: async ({ id }: deleteFileParams) => {
      return await getApiClient({ workspaceId, botId }).deleteFile({ id }).catch(handleHttpErrors)
    },
    onSuccess: async () => {
      showSuccessToast('File deleted successfully')
      queryClient.invalidateQueries({ queryKey: listFilesQueryKey })
    },
    onError: async (error: Error) => {
      showErrorToast(error.message)
    },
  })
}
